// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusBox_container__lGivE {
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 0.5rem;
  border-radius: 2px;
  min-width: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.StatusBox_containerClickable__ZZkq2 {
  cursor: pointer;
}

.StatusBox_containerClickable__ZZkq2:hover {
  background: #d8edeb;
}

.StatusBox_active__IqZy9 {
  background: var(--primaryColor);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/StatusBox.module.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".container {\n  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n  padding: 0.5rem;\n  border-radius: 2px;\n  min-width: 100px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n}\n\n.containerClickable {\n  cursor: pointer;\n}\n\n.containerClickable:hover {\n  background: #d8edeb;\n}\n\n.active {\n  background: var(--primaryColor);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StatusBox_container__lGivE`,
	"containerClickable": `StatusBox_containerClickable__ZZkq2`,
	"active": `StatusBox_active__IqZy9`
};
export default ___CSS_LOADER_EXPORT___;
